import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/files';

export const createFile = async (payload) =>
  await ajax('POST', `${rootUrl}`, JSON.stringify(payload));

export const updateFile = async ({ fileKey, payload }) =>
  await ajax('PUT', `${rootUrl}/${fileKey}`, JSON.stringify(payload));

export const deleteFile = async (fileKey) => await ajax('DELETE', `${rootUrl}/${fileKey}`);

export const addFileToQuestion = async (payload) =>
  await ajax('POST', `${rootUrl}/fileToQuestion`, JSON.stringify(payload));

export const deleteFileFromQuestion = async (fileKey) =>
  await ajax('DELETE', `${rootUrl}/fileToQuestion/${fileKey}`);
